import { WifiStrength2AlertIcon } from './WifiStrength2AlertIcon';

/**
 * author: Simran
 * id 38D73A8E-CEA5-4E6F-960B-BD2A0D482D9F
 * name wifi-strength-2-alert
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-strength-2-alert.svg
 * tags
 * - Alert / Error 
 */
export const WifiStrength2WarningIcon = WifiStrength2AlertIcon;
export default WifiStrength2WarningIcon